import { BuildingType } from '@/interfaces/valuation/types/BuildingValuationStep'
import { ResponseLinks } from '@/interfaces/app/ResponseLinks'

export interface IValuationPreview {
  id: number
  uid: string
  created: Date
  location: string
  buildingType: BuildingType
  valuationPrice: number
  pdf: string
  links: ResponseLinks
}

export class ValuationPreview implements IValuationPreview {
  public id: number
  public uid: string
  public created: Date
  public location: string
  public buildingType: BuildingType
  public valuationPrice: number
  public pdf: string
  public links: ResponseLinks

  constructor(data: any) {
    this.id = data.id
    this.uid = data.valuationNumber
    this.created = new Date(data.created)
    this.location = data.location
    this.buildingType = data.buildingType
    this.valuationPrice = data.valuationPriceTotal
    this.pdf = data.pdf
    this.links = data.links
  }
}

export class ValuationConcept implements IValuationPreview {
  public id: number
  public uid: string
  public created: Date
  public location: string
  public buildingType: BuildingType
  public valuationPrice: number
  public pdf: string
  public links: ResponseLinks

  constructor(data: any) {
    this.id = data.id || 'N/A'
    this.uid = data.valuationNumber || 'N/A'
    this.created = new Date(data.created)
    this.location = data.location || 'N/A'
    this.buildingType = data.buildingType || 'N/A'
    this.valuationPrice = data.valuationPriceTotal || 0
    this.pdf = data.pdf || 'N/A'
    this.links = data.links || 'N/A'
  }
}
